import {Component, inject, OnInit, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {Card} from 'primeng/card';
import {MultiTabStepBaseComponent} from '../../../../../../shared/tabs/multi-tab-step-base.component';
import {TabStatus} from '../../../../../../shared/tabs/tab-status.model';
import {TabStatusDirective} from '../../../../../../shared/tabs/tab-status.directive';
import {
  MAIL_PREVIEW_FIELD_MAP,
  MAIL_PREVIEW_SECTIONS,
  Step52RfiMailPreviewComponent,
} from './step-5-2-rfi-mail-preview/step-5-2-rfi-mail-preview.component';
import {
  PROJECT_DESCRIPTION_FIELD_MAP,
  PROJECT_DESCRIPTION_SECTIONS,
  Step52RfiProjectDescriptionComponent,
} from './step-5-2-rfi-project-description/step-5-2-rfi-project-description.component';
import {
  ProjectStepRichTextService,
  calculateRichTextSectionStatus,
} from '../../../../../../shared/services/project-step-rich-text.service';
import {
  TenderInvitationPreviewControllerService,
  TenderInvitationPreviewResponse,
  TenderPhaseType,
} from '@frontend/shared-api';
import {createTabStatusSignal} from '../../../../../../shared/tabs/tab-utils';
import {TabsUnsavedRevealDirective} from '../../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-step-5-2-rfi-invitation-preview',
  providers: [ProjectStepRichTextService],
  imports: [
    TranslocoPipe,
    Tab,
    TabList,
    Tabs,
    TabPanels,
    TabPanel,
    Card,
    Step52RfiMailPreviewComponent,
    Step52RfiProjectDescriptionComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './step-5-2-rfi-invitation-preview.component.html',
})
export class Step52RfiInvitationPreviewComponent
  extends MultiTabStepBaseComponent
  implements OnInit
{
  private readonly tenderInvitationPreviewControllerService = inject(
    TenderInvitationPreviewControllerService,
  );
  protected readonly mailPreviewTabStatus = createTabStatusSignal();
  protected readonly rfiProjectDescriptionTabStatus = createTabStatusSignal();

  invitationPreviewResponse = signal<TenderInvitationPreviewResponse | undefined>(undefined);

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadAllTabData();
  }

  private loadAllTabData(): void {
    this.tenderInvitationPreviewControllerService
      .getTenderInvitationPreview({
        projectId: this.projectId,
        phase: TenderPhaseType.RFI,
      })
      .subscribe({
        next: (data) => {
          this.invitationPreviewResponse.set(data);
          this.calculateInitialTabStatuses();
        },
      });
  }

  private calculateInitialTabStatuses(): void {
    const invitationData = this.invitationPreviewResponse();

    if (invitationData) {
      const richTextCompleted = calculateRichTextSectionStatus(
        invitationData,
        PROJECT_DESCRIPTION_SECTIONS,
        PROJECT_DESCRIPTION_FIELD_MAP,
      );

      const projectDescriptionStatus = {
        totalSections: PROJECT_DESCRIPTION_SECTIONS.length,
        completedSections: richTextCompleted,
      };
      this.onRfiProjectDescriptionStatusChange(projectDescriptionStatus);

      const mailPreviewCompleted = calculateRichTextSectionStatus(
        invitationData,
        MAIL_PREVIEW_SECTIONS,
        MAIL_PREVIEW_FIELD_MAP,
      );

      const mailPreviewStatus = {
        totalSections: MAIL_PREVIEW_SECTIONS.length,
        completedSections: mailPreviewCompleted,
      };
      this.onMailPreviewStatusChange(mailPreviewStatus);
    }
  }

  onMailPreviewStatusChange(status: TabStatus): void {
    this.mailPreviewTabStatus.update(status);
  }

  onRfiProjectDescriptionStatusChange(status: TabStatus): void {
    this.rfiProjectDescriptionTabStatus.update(status);
  }
}
